import { InspectorControls } from '@wordpress/block-editor';
import TimelineSettings from './timeline-settings';
import StyleControls from './style-controls';

export default function AllInspectorControls( { attributes, setAttributes } ) {
	return (
		<InspectorControls>
			<TimelineSettings
				attributes={ attributes }
				setAttributes={ setAttributes }
			/>
			<StyleControls
				attributes={ attributes }
				setAttributes={ setAttributes }
			/>
		</InspectorControls>
	);
}
